module.exports = __webpack_public_path__ + "img/hr-uranium-ore.98dc342b.png";